import { START_LOCATION } from 'vue-router'
import { nextGeneration } from '~/libs/data-generation'

// Non-GET requests that only read or track; they don't change borrower data.
const READ_ONLY_POSTS = [
  /\/auth\/idp$/,
  /\/borrower-portal\/identity\/exists$/,
  /\/authorization\/pusher$/,
  /\/borrower-portal-page-views$/,
]

function isWrite(config) {
  const method = (config?.method ?? 'get').toLowerCase()
  if (method === 'get') return false
  const url = (config?.url ?? '').split('?')[0]
  return !READ_ONLY_POSTS.some(pattern => pattern.test(url))
}

export default defineNuxtPlugin({
  name: 'dataGeneration',
  dependsOn: ['axiosSetup'],
  setup({ $axios, $axiosWithRetry }) {
    for (const client of [$axios, $axiosWithRetry]) {
      client.interceptors.request.use((config) => {
        if (isWrite(config)) nextGeneration()
        return config
      })
      client.interceptors.response.use(
        (response) => {
          if (isWrite(response?.config)) nextGeneration()
          return response
        },
        (error) => {
          if (isWrite(error?.config)) nextGeneration()
          return Promise.reject(error)
        },
      )
    }

    useRouter().beforeEach((to, from) => {
      if (from !== START_LOCATION && to.path !== from.path) nextGeneration()
    })
  },
})
